import { render, staticRenderFns } from "./TabTableRziDocumentation.vue?vue&type=template&id=b665431c&scoped=true&"
import script from "./TabTableRziDocumentation.vue?vue&type=script&lang=js&"
export * from "./TabTableRziDocumentation.vue?vue&type=script&lang=js&"
import style0 from "./TabTableRziDocumentation.vue?vue&type=style&index=0&id=b665431c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b665431c",
  null
  
)

export default component.exports